import React from 'react'
import {FaGithub,FaLinkedin,FaTwitter} from "react-icons/fa"
const Footer = () => {
  return (
    <div >
        <div className='flex justify-around items-center w-full h-16 mx-auto bg-slate-800'>
            <p className=' text-white ml-2'>Developed by Supriyo Samanta</p>
            {/* <p className=' text-white'>Designed and Developed by Supriyo Samanta</p> */}
            <div className='w-1/2 md:w-1/12 flex justify-around items-center'>
            <FaLinkedin size={20} className="text-white cursor-pointer" />
            <FaGithub size={20} className="text-white cursor-pointer" />
            <FaTwitter size={20} className="text-white cursor-pointer"/>
            </div>
        </div>
    </div>
  )
}

export default Footer